import type { FC } from "react";
import {
  Advantage,
  AdvantageText,
  AdvantageTitle,
  TextWrapper,
  Group,
  Iconwrapper,
  Subtitle,
} from "./description.styles";
import { DescriptionText } from "../../price-page.styles";
import { ReactComponent as AdvantageIcon } from "@src/core/icons/advantage.svg";

export const Description: FC = () => {
  return (
    <div>
      <TextWrapper>
        <Subtitle>Что такое LightBoxAPI</Subtitle>
        <DescriptionText>
            LightBox API — система для создания быстрых и легковесных api методов. При созданиии API метода вам доступны гибкие настройки по его управлению: код ответа, url запроса, метод запроса, тело ответа, логирование запросов.
            Можно в автоматическом режиме импортировать документацию из swagger и postman файлов, на их основе будут созданы API методы. LightBox API подходит как для тех кто хочет замокать и протестировать стороннее API, так и для продакшен среды, когда еще нет бекенд, а фронт уже готов.
        </DescriptionText>
      </TextWrapper>
      <Group>
        <Advantage>
          <Iconwrapper>
            <AdvantageIcon />
          </Iconwrapper>
          <div>
            <AdvantageTitle>Простота и удобство</AdvantageTitle>
            <AdvantageText>
                Для того, чтобы создать API метод вам нужно, потратить минимальное количество времени.
            </AdvantageText>
          </div>
        </Advantage>
        <Advantage>
          <Iconwrapper>
            <AdvantageIcon />
          </Iconwrapper>
          <div>
            <AdvantageTitle>Автоматика</AdvantageTitle>
            <AdvantageText>
                Доступно автоматическое создание API по swagger и postman файлам.
            </AdvantageText>
          </div>
        </Advantage>
        <Advantage>
          <Iconwrapper>
            <AdvantageIcon />
          </Iconwrapper>
          <div>
            <AdvantageTitle>Индивидуальный поддомен</AdvantageTitle>
            <AdvantageText>
                После создания аккаунта в системе, вам выделяется поддомен с вашим логином указанным при регистрации.
            </AdvantageText>
          </div>
        </Advantage>
      </Group>
    </div>
  );
};
